import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { DrawerService } from '../../services/drawer.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-drawer',
  standalone: true,
  imports: [MatSidenavModule, MatDialogModule, MatIconModule, CommonModule],
  templateUrl: './drawer.component.html',
  styleUrl: './drawer.component.scss',
})
export class DrawerComponent implements AfterViewInit {
  @ViewChild('drawer')
  drawer!: MatDrawer;

  constructor(public drawerService: DrawerService) {}

  ngAfterViewInit() {
    this.drawerService.drawer = this.drawer;
  }
}
